import React, { ReactNode } from "react";

// Stores
import WindowStore from "Stores/WindowStore";

// Assets
import { ReactComponent as ChevronUp } from "assets/images/icons/chevron-up.svg";

// Styles
import classes from "./classes.module.scss";

type IProps = {
	icon?: ReactNode;
	label: string | ReactNode;
	onOpen?: (isOpen: boolean) => void;
	closeAction?: (closabled: () => void) => void;
	children?: ReactNode;
};

type IState = {
	open: boolean;
	dropdownHeight: number;
	animate: boolean;
};

export default class Dropdown extends React.Component<IProps, IState> {
	private removeOnresize = () => {};
	private contentRef = React.createRef<HTMLDivElement>();

	constructor(props: IProps) {
		super(props);
		this.state = {
			open: false,
			dropdownHeight: 0,
			animate: true,
		};

		this.toggle = this.toggle.bind(this);
	}

	public override render(): JSX.Element | null {
		return (
			<div className={classes["root"]} data-open={this.state.open} data-animate={this.state.animate}>
				<div className={classes["dropdown-header-container"]} onClick={this.toggle}>
					<div className={classes["dropdown-left-part"]}>
						{this.props.icon}
						<p className={classes["dropdown-label"]}>{this.props.label}</p>
					</div>
					<ChevronUp className={classes["dropdown-arrow"]} />
				</div>
				<div
					className={classes["dropdown-content-container"]}
					style={{ height: this.state.dropdownHeight + "px" }}
					ref={this.contentRef}>
					<div className={classes["dropdown-content"]}>{this.props.children}</div>
				</div>
			</div>
		);
	}

	public override componentDidMount() {
		this.removeOnresize = WindowStore.getInstance().onResize(() => this.onResize());
		if (!this.props.closeAction) return;
		this.props.closeAction(() => this.close());
	}

	public override componentWillUnmount() {
		this.removeOnresize();
	}

	private close() {
		this.setState({
			dropdownHeight: 0,
			open: false,
			animate: true,
		});
	}

	private onResize() {
		if (!this.state.open) return;
		this.setState(
			{
				dropdownHeight: 0,
				animate: false,
			},
			() => {
				let dropdownHeight = 0;
				if (this.state.open) dropdownHeight = this.contentRef.current?.scrollHeight ?? 0;
				this.setState({
					dropdownHeight,
					animate: false,
				});
			},
		);
	}

	private toggle() {
		if (this.props.onOpen && !this.state.open) {
			this.props.onOpen(false);
		}

		let dropdownHeight = 0;
		if (!this.state.open) dropdownHeight = this.contentRef.current?.scrollHeight ?? 0;

		this.setState({
			dropdownHeight,
			open: !this.state.open,
			animate: true,
		});
	}
}
